export default __webpack_public_path__ + "static/media/titleDesktop3x.eff96523.png";